import PropTypes from "prop-types"
import React from "react"
import CountUp from "react-countup"
import Visibility from "../visibility"

class IndustrySim extends React.Component {
  static propTypes = {
    blockIndustrySim: PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.string,
      link1: PropTypes.string,
    }),
    animate: PropTypes.bool,
  }

  static defaultProps = {
    blockIndustrySim: {
      title: ``,
      content: ``,
      link1: ``,
    },
    animate: true,
  }

  state = {
    hover: {}
  }

  render () {
    return (
      <div className="col col-12 bg-mercer-glass-dark black p2 md-px3 relative mb2">
        <div className="col col-12 center">
          <h3 className="mt0 uppercase fg-mercer-gray-dark letter-space-1.5">{this.props.blockIndustrySim.title}</h3>
          <div className="col col-12">
            <h4 className="fg-mercer-gray-dark mt0 mb2">{this.props.blockIndustrySim.content}</h4>
            <h4 className="fg-mercer-gray-dark mt0 mb2 italic">Roll-over each industry to learn more.</h4>
          </div>
        </div>
        <div className="col col-12 p1">
          {this.props.data.overview.filter((edge) => !isNaN(parseFloat(edge.value))).map((edge) => {
            const detailed = this.props.data.detailed.filter((detailedData) => detailedData.industry === edge.industry);
            const value = parseFloat(isNaN(edge.value) ? 0 : edge.value);
            const maximum = Math.max(...this.props.data.overview.map((item) => isNaN(parseFloat(item.value)) ? 0 : parseFloat(item.value)));
            const width = value / maximum * 100;
            const graphData = {
              salaryFreeze: detailed.find((detailedData) => detailedData.bucket === "Salary Freeze") || { node: {} },
              zeroToOne: detailed.find((detailedData) => detailedData.bucket === "0 - 1") || { node: {} },
              oneToTwo: detailed.find((detailedData) => detailedData.bucket === "1 - 2") || { node: {} },
              twoToThree: detailed.find((detailedData) => detailedData.bucket === "2 - 3") || { node: {} },
              threeToFour: detailed.find((detailedData) => detailedData.bucket === "3 - 4") || { node: {} },
              fourToFive: detailed.find((detailedData) => detailedData.bucket === "4 - 5") || { node: {} },
              greaterThanFive: detailed.find((detailedData) => detailedData.bucket === "5 +") || { node: {} },
            };
            return (
              <div key={edge.industry} className="col col-12">
                <div className="col col-12 md-col-3 lg-col-2 left fg-mercer-gray-dark capitalize nowrap">{edge.industry}</div>
                <div className="col col-12 md-col-9 lg-col-10">
                  <span className="col col-10 lg-col-11 bg-white popup-hover" onMouseOver={() => this.setState((prevState) => ({
                    hover: {
                      ...prevState.hover,
                      [edge.industry]: true,
                    }
                  }))} onMouseOut={() => this.setState({ hover: {} })}>
                    <Visibility>
                      {({ isVisible }) => (
                        <span
                          className="col bg-mercer-blue-gradient"
                          style={{
                            width: `${isVisible ? width : 0}%`,
                            height: "14px",
                            transition: "width 625ms ease-in-out"
                          }}
                        ></span>
                      )}
                    </Visibility>
                    <span className="popup-content">
                      <div className="col-12 md-col-8 lg-col-6 mx-auto bg-white border center p2 arrow_box">
                        <h3 className="mt0 fg-mercer-blue-bright uppercase regular letter-space-1.5">{edge.industry}</h3>
                        <div className="flex line-height-1 fg-mercer-gray-dark" style={{width: "100%", height:"160px"}}>
                          <div style={{
                            width: "16px",
                            height: "140px"
                          }}>
                            <span
                              className="fg-mercer-gray-mid center italic h6"
                              style={{
                                display: "block",
                                transform: "rotate(-90deg)",
                                marginTop: "160px",
                                whiteSpace: "nowrap",
                                transformOrigin: "left top",
                              }}
                            >
                              Proportion of incumbents (%)
                            </span>
                          </div>
                          <div className="thin flex flex-column flex-justify flex-end" style={{width: "30px"}}>
                            <div>
                              100
                            </div>
                            <div>
                              80
                            </div>
                            <div>
                              60
                            </div>
                            <div>
                              40
                            </div>
                            <div>
                              20
                            </div>
                            <div>
                              0
                            </div>
                          </div>
                          <div className="flex-auto flex flex-column flex-justify-end px1 flex-1">
                            <div className="bold mb1">{graphData.salaryFreeze.value}</div>
                            <div className="bg-mercer-blue-bright" style={{height: this.state.hover[edge.industry] ? graphData.salaryFreeze.value : 0, width:"100%", transition: "height 625ms ease-in"}} />
                          </div>
                          <div className="flex-auto flex flex-column flex-justify-end px1 flex-1">
                            <div className="bold mb1">{graphData.zeroToOne.value}</div>
                            <div className="bg-mercer-blue-bright" style={{height: this.state.hover[edge.industry] ? graphData.zeroToOne.value : 0, width:"100%", transition: "height 625ms ease-in"}} />
                          </div>
                          <div className="flex-auto flex flex-column flex-justify-end px1 flex-1">
                            <div className="bold mb1">{graphData.oneToTwo.value}</div>
                            <div className="bg-mercer-blue-bright" style={{height: this.state.hover[edge.industry] ? graphData.oneToTwo.value : 0, width:"100%", transition: "height 625ms ease-in"}} />
                          </div>
                          <div className="flex-auto flex flex-column flex-justify-end px1 flex-1">
                            <div className="bold mb1">{graphData.twoToThree.value}</div>
                            <div className="bg-mercer-blue-bright" style={{height: this.state.hover[edge.industry] ? graphData.twoToThree.value : 0, width:"100%", transition: "height 625ms ease-in"}} />
                          </div>
                          <div className="flex-auto flex flex-column flex-justify-end px1 flex-1">
                            <div className="bold mb1">{graphData.threeToFour.value}</div>
                            <div className="bg-mercer-blue-bright" style={{height: this.state.hover[edge.industry] ? graphData.threeToFour.value : 0, width:"100%", transition: "height 625ms ease-in"}} />
                          </div>
                          <div className="flex-auto flex flex-column flex-justify-end px1 flex-1">
                            <div className="bold mb1">{graphData.fourToFive.value}</div>
                            <div className="bg-mercer-blue-bright" style={{height: this.state.hover[edge.industry] ? graphData.fourToFive.value : 0, width:"100%", transition: "height 625ms ease-in"}} />
                          </div>
                          <div className="flex-auto flex flex-column flex-justify-end px1 flex-1">
                            <div className="bold mb1">{graphData.greaterThanFive.value}</div>
                            <div className="bg-mercer-blue-bright" style={{height: this.state.hover[edge.industry] ? graphData.greaterThanFive.value : 0, width:"100%", transition: "height 625ms ease-in"}} />
                          </div>
                        </div>
                        <div className="flex line-height-1 fg-mercer-gray-dark pt1" style={{width: "100%", height:"18px"}}>
                          <div style={{width: "30px", height: "100%"}}>
                          </div>
                          <div className="flex-1 px1">0%</div>
                          <div className="flex-1 px1">0-1%</div>
                          <div className="flex-1 px1">1-2%</div>
                          <div className="flex-1 px1">2-3%</div>
                          <div className="flex-1 px1">3-4%</div>
                          <div className="flex-1 px1">4-5%</div>
                          <div className="flex-1 px1">>5%</div>
                        </div>
                        <div className="col col-12 fg-mercer-gray-mid pt1 center italic h6" style={{width: "100%", height:"18px"}}>
                          Same Incumbent Movements
                        </div>
                      </div>
                    </span>
                  </span>
                  <Visibility>
                    {({ isVisible }) => (
                      <span className="col col-2 lg-col-1 right-align bold fg-mercer-gray-dark"><CountUp duration={2.5} end={ isVisible ? value : 0 } decimals={parseFloat(value).toFixed(2).split(".")[1][1] === "0" ? 1 : 2} />%</span>
                    )}
                  </Visibility>
                </div>
              </div>
            );
          })}
        </div>
        <div className="col col-12 mt2 center">
          <a href={this.props.blockIndustrySim.link1} target="_parent" className="btn btn-primary bg-mercer-gray-light fg-mercer-gray-dark">Salary Survey & Reports</a>
        </div>
      </div>
    )
  }
}

export default IndustrySim
